import { gql } from '@mineko/graphql-client';

export default gql`
  query {
    default: GetIntegratedPartners(type: default) {
      id
      name
    }

    legalInsurances: GetIntegratedPartners(type: legalInsurance) {
      id
      name
      options
    }

    broker: GetIntegratedPartners(type: broker) {
      id
      name
    }
  }
`;
